import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

export default function Navbar({ transparent = false }) {
    const { pathname } = useLocation();
    const isHome = pathname === "/";

    return (
        <motion.nav
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 ${
                transparent ? "bg-transparent" : "bg-black/40 backdrop-blur-xl border-b border-white/5"
            }`}
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
                <Link to="/" data-testid="navbar-logo" className="group flex items-center gap-3">
                    <span className="block w-2 h-2 rounded-full bg-[var(--rb-primary)] group-hover:bg-[var(--rb-secondary)] transition-colors" />
                    <span className="font-display text-xl tracking-wide text-white">
                        rabitsch<span className="text-[var(--rb-primary)]">.</span>supporter
                    </span>
                </Link>
                <div className="flex items-center gap-7 text-sm uppercase tracking-[0.18em] text-zinc-400">
                    {!isHome && (
                        <Link
                            to="/"
                            data-testid="nav-home"
                            className="hover:text-[var(--rb-secondary)] transition-colors"
                        >
                            Start
                        </Link>
                    )}
                    <Link
                        to="/thomas"
                        data-testid="nav-thomas"
                        className={`hover:text-[var(--rb-secondary)] transition-colors ${
                            pathname === "/thomas" ? "text-white" : ""
                        }`}
                    >
                        Thomas
                    </Link>
                    <Link
                        to="/bernhard"
                        data-testid="nav-bernhard"
                        className={`hover:text-[var(--rb-secondary)] transition-colors ${
                            pathname === "/bernhard" ? "text-white" : ""
                        }`}
                    >
                        Bernhard
                    </Link>
                    <Link
                        to="/gaestebuch"
                        data-testid="nav-guestbook"
                        className={`hover:text-[var(--rb-primary)] transition-colors ${
                            pathname === "/gaestebuch" ? "text-white" : ""
                        }`}
                    >
                        Gästebuch
                    </Link>
                </div>
            </div>
        </motion.nav>
    );
}
